export const DRAG_DISTANCE = 2;
export const DRAG_LIBRARY = 'library';
export const DRAG_WORKSPACE = 'workspace';

export const CLONE_DISTANCE = 12;

export const OUTSIDE_WORKSPACE_RATIO = 0.65;

export const LIBRARY_ID = 'library';
export const WORKSPACE_ID = 'workspace';
